/** An error that will be thrown whenever an invalid violation type is seen */
export class InvalidViolationTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Error.captureStackTrace(this, InvalidViolationTypeError);
  }
}
